<template>
    <div>
        <form @submit.prevent="addRecord">
            <table dusk="insert-record" class="table | u-margin-bottom-flush">
                <tr class="dns-zones__flex-row">
                    <td>
                        <div class="dns-zones__select-wrapper">
                            <select
                                id="type"
                                v-model="form.type"
                                :placeholder="trans('page.dns.table.type')"
                                class="field__input field--custom-select dns-zones__input | u-margin-bottom-flush"
                            >
                                <option v-for="type in types" :key="type" :value="type">{{ type }}</option>
                            </select>
                            <img class="dns-zones__select-icon" src="../assets/feather-icons/chevron-down.svg" />
                        </div>
                    </td>
                    <td>
                        <simple-text-input
                            v-model="form.name"
                            :placeholder="trans('page.dns.table.name')"
                            :error="form.errors.first('name')"
                            name="name"
                        />
                    </td>
                    <td>
                        <simple-text-input
                            v-model="form.content"
                            :placeholder="trans('page.dns.table.content')"
                            :error="form.errors.first('content')"
                            name="content"
                            @focus="showModal"
                        />
                    </td>
                    <td>
                        <simple-select-input
                            v-model="form.ttl"
                            :placeholder="trans('page.dns.table.ttl')"
                            :error="form.errors.first('new.ttl')"
                            :options="ttls"
                            name="ttl"
                        />
                    </td>
                    <td>
                        <button class="btn btn--ghost dns-zones__button" type="submit">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <use xlink:href="../assets/feather-icons/icons.svg#plus"></use>
                            </svg>
                        </button>
                    </td>
                </tr>
            </table>
        </form>

        <mx-modal
            v-if="mxModalVisible"
            @close="closeModal"
            @value="updateMxRecord"
            :type="form.type"
            :content="form.content"
            :priority="form.priority"
        />

        <srv-modal
            v-if="srvModalVisible"
            @close="closeModal"
            @value="updateSrvRecord"
            :type="form.type"
            :name="form.name"
            :content="form.content"
            :priority="form.priority"
            :weight="form.weight"
            :port="form.port"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formMixin, Way2Form } from 'relapp-way2forms';
import ttls from '../config/ttls.json';
import { EventBus } from 'relapp-event';
import { apiMixin } from 'relapp-api';
import DnsApi from '../services/api/dns.js';

import MxModal from './modals/MxModal.vue';
import SrvModal from './modals/SrvModal.vue';

export default {
    components: {
        MxModal,
        SrvModal
    },
    mixins: [formMixin, apiMixin],
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                type: 'A',
                name: null,
                content: null,
                ttl: 600,
                priority: null,
                weight: null,
                port: null,
                target: ''
            }),
            types: ['A', 'AAAA', 'CAA', 'CNAME', 'MX', 'SRV', 'TLSA', 'TXT'],
            ttls: ttls,
            mxModalVisible: false,
            srvModalVisible: false
        };
    },
    methods: {
        ...mapActions({
            addDnsRecord: 'dns/addRecord',
            setDnsStatus: 'dns/setStatus'
        }),
        /**
         * Send the records to store for instant response, and to the backend to add the record to the dns.
         */
        addRecord() {
            if (!this.form.name) {
                this.form.name = this.domain;
            } else if (!this.form.name.toLowerCase().endsWith(this.domain.toLowerCase())) {
                this.form.name += '.' + this.domain;
            }

            const record = { ...this.form };

            this.setDnsStatus(true);

            DnsApi.add(this.form.data(), this.routeParams, record)
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.saved')
                    });
                    this.form.reset();
                })
                .catch(error => {
                    this.showValidationErrors(error, this.form);
                })
                .then(() => {
                    this.setDnsStatus(false);
                });
        },

        /**
         * Show the modal if the record type is an MX or SRV record.
         */
        showModal() {
            if (this.form.type == 'MX') {
                this.mxModalVisible = true;
            }

            if (this.form.type == 'SRV') {
                this.srvModalVisible = true;
            }
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.mxModalVisible = false;
            this.srvModalVisible = false;
        },

        /**
         * Updated value for the mx record.
         *
         * @param {object} record
         */
        updateMxRecord(record) {
            this.form.name = record.name;
            this.form.content = record.content;
            this.form.priority = parseInt(record.priority);
            this.form.weight = null;
            this.form.port = null;
        },

        /**
         * Updated value for the srv record.
         *
         * @param {object} record
         */
        updateSrvRecord(record) {
            this.form.name = record.name;
            this.form.priority = parseInt(record.priority);
            this.form.weight = parseInt(record.weight);
            this.form.port = parseInt(record.port);
            this.form.content = record.content;
        }
    }
};
</script>
